// geoHelper.js - Safe Mapbox Version (Fixed)

const MAPBOX_API_KEY = "pk.eyJ1IjoiZGV2bG9naWMiLCJhIjoiY21uODV0d3lvMDd4ODJxb3BkNmZveTN1ZyJ9.z5YpX5hv4anicowK_UGYxw"
export const getCoords = async (address) => {
  // Strong safety check - this fixes the "trim is not a function" error
  if (!address || typeof address !== "string") {
    console.warn("Invalid address (not a string):", address);
    return null;
  }

  const cleanAddress = address.trim();
  if (cleanAddress === "") {
    console.warn("Empty address after trim");
    return null;
  }

  const query = `${cleanAddress}, Montreal, QC, Canada`;

  try {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${MAPBOX_API_KEY}&limit=1&country=CA`;

    const res = await fetch(url);

    if (!res.ok) {
      throw new Error(`Mapbox HTTP ${res.status}`);
    }

    const data = await res.json();

    if (data.features && data.features.length > 0) {
      const feature = data.features[0];
      return {
        lng: feature.center[0],
        lat: feature.center[1],
        displayName: feature.place_name
      };
    }

    console.warn(`No Mapbox coordinates found for: ${cleanAddress}`);
    return null;

  } catch (error) {
    console.error(`Mapbox geocoding failed for "${cleanAddress}":`, error.message);
    return null;
  }
};